import React, { useContext, useEffect, useCallback } from "react";
import { LoginFormContext, LoginFormContextType } from "../utils";
import { useTranslation } from "react-i18next";
import { AuthDataRes, BizTypeEnum } from "@/types/LoginPage";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import {
  IconSwitch,
  IconRight
} from "@/components/icon";
import { BackNav } from "../comps";
import styles from "../index.module.less";

export default function SelectAccountTypeForm({
  userTicketData,
  onPublicAccount,
  onPerCodeSuccess,
  onPerPwdSuccess,
  onTicketLoginSuccess
}: {
  userTicketData: AuthDataRes;
  onPublicAccount: () => void;
  onPerCodeSuccess: (authData: AuthDataRes) => void;
  onPerPwdSuccess: (authData: AuthDataRes) => void;
  onTicketLoginSuccess: (data: any) => void;
}) {
  const { navigate, onMobileChange, setResendLastTs, authInfo } = React.useContext<
    LoginFormContextType
  >(LoginFormContext);
  const { t } = useTranslation("common");
  const { onGlobalError: onLoginError, service } = useContext<GlobalContextConfig>(GlobalContext);

  const accountList = [
    {
      title: t("login.personalAccount"),
      desc: t("login.personalAccountDesc"),
      id: 'personal'
    }, {
      title: t("login.publicAccount"),
      desc: t("login.publicAccountDesc"),
      id: 'public'
    }
  ]

  const selAccount = useCallback(async(tag:string) => {
    if (tag === 'public') {
      onPublicAccount()
    } else if (tag === 'personal') {
      const { ticket, userId } = userTicketData
      onTicketLoginSuccess({
        ticket,
        userId,
        usageUserId: '',
        loginType: 'personal'
      })
    }
  }, [userTicketData])

  return (
    <div
      className={`${styles.mobileForm} ${styles.joinMe}`}
      style={{
        border: "1px solid rgba(240,243,243,1)",
        borderRadius: "6px",
        padding: 0,
        marginTop: "10px"
      }}
    >
      <div
        style={{
          // padding: "20px 30px 0 30px"
        }}
      >
        <BackNav
          clickHandle={() => {
            onMobileChange("");
            setResendLastTs(-1);
            setTimeout(() => {
              navigate("step1");
            }, 0);
          }}
          // icon={IconSwitch}
          title={t("login.changeLogin")}
          subtitle={t("login.selectAccount")}
        />
      </div>
      <div style={{marginTop: 30}}>
        <div className={styles.selectTeam}>
          <div className={styles.teamScroller}>
            {
              accountList.map((item: any, index: number) => {
                return (
                  <div
                    key={item.id}
                    onClick={() => {selAccount(item.id)}}
                    style={{
                      padding: '12px 16px',
                      borderRadius: '8px',
                      userSelect: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginBottom: '12px',
                      cursor: 'pointer',
                      border: "1px solid #E6E6E6"
                    }}
                  >
                    <div>
                      <div style={{ color: '#000', fontSize: '16px', fontWeight: 500}}>
                        {item.title}
                      </div>
                      <div style={{ color: '#818793', fontSize: '14px', fontWeight: 400 }}>
                        {item.desc}
                      </div>
                    </div>
                    {IconRight}
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    </div>
  ); 
}
